import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { ViegaCommonModule } from 'viega-common';
import { ArticlesComponent } from "./articles/articles.component";
import { ArticleCarouselComponent } from "./articles/article-carousel/article-carousel.component";
import { ArticleDetailsComponent } from "./articles/article-details/article-details.component";
import { MOBILE_ROUTES } from './mobile.routes';

@NgModule({
    declarations: [
        ArticlesComponent,
        ArticleCarouselComponent,
        ArticleDetailsComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        ViegaCommonModule,
        RouterModule.forChild(MOBILE_ROUTES)
    ]
})
export class MobileModule {}



// WEBPACK FOOTER //
// ./src/app/mobile/mobile.module.ts